export function selectViewCountOffsets(state) {
  return state.findAndFilterData.viewCounts.countOffsetsByViewId;
}
export function selectViewCounts(state) {
  return state.findAndFilterData.viewCounts.countByViewId;
}